import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { error, titles } from '../../../styles/colors';
import { CssSelectors, Layouts } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	audience: {
		border: THEME.common.border,
		borderColor: THEME.colors.border.light,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[12],
	},
	audienceChangeButton: {
		gap: SPACE[4],
		height: 'auto',
		padding: 0,
		':has(> svg)': {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	audienceHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	audienceLabel: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	audienceSummary: {
		alignItems: 'center',
		color: THEME.colors.text.main,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[8],
	},
	contactsCountSpinner: {
		margin: '0 auto',
	},
	TagEmailRecipientsList: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 'auto',
		width: '100%',
		...CssSelectors.allChildren({
			width: '100%',
		}),
	},
	filterDropdownTrigger: {
		width: '100%',
	},
	groupingLabel: {
		fontSize: '0.75rem',
	},
	header: {
		...Layouts.verticalStack(16),
		boxSizing: 'border-box',
		padding: '0px 0 10px 0',
	},
	headerCount: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: 14,
		justifyContent: 'flex-start',
	},
	headerCountNumbers: {},
	headerCountNumbersImportant: {
		color: error,
	},
	headerCountPolicies: {
		// to override the verticalStack
		':nth-child(1n):nth-child(1n)': {
			marginTop: 0,
		},
	},
	headerOptions: {
		color: '#858585',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: 14,
		marginBottom: '0.5rem',
	},
	headerTitle: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		fontSize: 18,
		justifyContent: 'space-between',
	},
	list: {
		flexGrow: 1,
		overflowY: 'auto',
		minHeight: 250,
	},
	recipientCountWithSort: {
		marginRight: 8,
	},
	select: {
		':not(:last-child)': {
			marginBottom: 10,
		},
		maxWidth: '100%',
	},
	sort: {
		border: 'none',
	},
	sortText: {
		color: titles,
		fontSize: 14,
		marginRight: 8,
	},
	sortTrigger: {
		padding: 0,
	},
	showingContentClassName: {
		width: '100% !important',
	},
	triggerText: {
		color: titles,
		paddingLeft: 10,
		width: '80%',
	},
	filterSummary: {
		color: '#858585',
		fontSize: 12,
		padding: '4px 0',
	},
	footer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		paddingTop: 8,
		marginTop: 'auto',
	},
});
